@import "tailwindcss";

@theme {
  --color-primary-50: #f0f9ff;
  --color-primary-100: #e0f2fe;
  --color-primary-200: #bae6fd;
  --color-primary-300: #7dd3fc;
  --color-primary-400: #38bdf8;
  --color-primary-500: #0ea5e9;
  --color-primary-600: #0284c7;
  --color-primary-700: #0369a1;
  --color-primary-800: #075985;
  --color-primary-900: #0c4a6e;

  --color-secondary-50: #f8fafc;
  --color-secondary-100: #f1f5f9;
  --color-secondary-200: #e2e8f0;
  --color-secondary-300: #cbd5e1;
  --color-secondary-400: #94a3b8;
  --color-secondary-500: #64748b;
  --color-secondary-600: #475569;
  --color-secondary-700: #334155;
  --color-secondary-800: #1e293b;
  --color-secondary-900: #0f172a;

  --font-sans: 'Inter', system-ui, sans-serif;
  --font-heading: 'Quicksand', system-ui, sans-serif;

  --animate-fade-in: fadeIn 0.5s ease-in-out;
  --animate-slide-up: slideUp 0.5s ease-out;
  --animate-bounce-slow: bounce 2s infinite;

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  @keyframes slideUp {
    0% { transform: translateY(20px); opacity: 0; }
    100% { transform: translateY(0); opacity: 1; }
  }
}

@layer base {
  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Inter', system-ui, sans-serif;
    --border-color: #0E666F;
  }
}

@layer components {
  .btn-primary {
    @apply bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200;
  }

  .btn-secondary {
    @apply bg-white hover:bg-gray-50 text-primary-600 font-semibold py-3 px-6 rounded-lg border border-primary-600 transition-colors duration-200;
  }

  .card {
    @apply bg-white rounded-xl shadow-lg p-6 border border-gray-100;
  }

  .gradient-bg {
    @apply bg-gradient-to-br from-primary-50 to-primary-100;
  }

  .text-brand-teal {
    color: #0E666F;
  }
}

@keyframes reverse-spin {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}

.animate-reverse-spin {
  animation: reverse-spin 1s linear infinite;
}

/*
 * Tailwind v4 generates `--tw-gradient-position: to bottom right in oklab`
 * where `in oklab` is appended to the direction without a preceding comma,
 * producing invalid CSS (`linear-gradient(to bottom right in oklab, ...)`).
 * The CSS spec requires `in <color-space>` BEFORE the direction, separated
 * by a comma. Override the position to strip `in oklab` so gradients render.
 */
.bg-gradient-to-t { --tw-gradient-position: to top; }
.bg-gradient-to-tr { --tw-gradient-position: to top right; }
.bg-gradient-to-r { --tw-gradient-position: to right; }
.bg-gradient-to-br { --tw-gradient-position: to bottom right; }
.bg-gradient-to-b { --tw-gradient-position: to bottom; }
.bg-gradient-to-bl { --tw-gradient-position: to bottom left; }
.bg-gradient-to-l { --tw-gradient-position: to left; }
.bg-gradient-to-tl { --tw-gradient-position: to top left; }
